// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3uTnj","imageUploader":"EGiftCard_imageUploader__384A0"};